import { useEffect, useState } from "react";
import { CircularProgress, Container, Grid, Stack } from "@mui/material";
import CreateValidatedQuestionFilters from "../../organisms/CreateValidatedQuestionFilters/CreateValidatedQuestionFilters.component";
import CreateValidatedQuestionForm from "../../organisms/CreateValidatedQuestionForm/CreateValidatedQuestionForm.component";
import { useForm, useWatch } from "react-hook-form";
import { exchangeProfileSchema } from "./schema/ExchangeProfile.schema";

interface FormValues {
    exchangeProfile: string;
    version: string;
    indicators: string[];
}

export const CreateValidatedQuestion = () => {
    const [exchangeProfilesLoading, setExchangeProfilesLoading] =
        useState(false);
    const [exchangeProfiles, setExchangeProfiles] = useState<
        { title: string; source: string }[]
    >([]);

    const {
        control,
        formState: { errors },
        setValue,
    } = useForm<FormValues>({
        defaultValues: {
            exchangeProfile: "",
            version: "",
            indicators: [],
        },
    });

    const exchangeProfile = useWatch({
        control,
        name: "exchangeProfile",
    });

    const watchedVersion = useWatch({
        control,
        name: "version",
    });

    useEffect(() => {
        if (exchangeProfile) {
            setValue("version", "");
            setValue("indicators", []);
        }
    }, [exchangeProfile]);

    useEffect(() => {
        if (watchedVersion) {
            setValue("indicators", []);
        }
    }, [watchedVersion]);

    useEffect(() => {
        const fetchExchangeProfiles = async () => {
            setExchangeProfilesLoading(true);

            const apiUrl = encodeURI(
                `${import.meta.env.VITE_PUBLICATIE_API_URL}/v1.1/exchange-profiles`
            );

            try {
                const response = await fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const data = await response.json();
                setExchangeProfiles(data);
            } catch (error) {
                console.error("Error fetching exchange profiles:", error);
            } finally {
                setExchangeProfilesLoading(false);
            }
        };
        void fetchExchangeProfiles();
    }, []);

    const version = useWatch({
        control,
        name: "version",
    });

    const selectedIndicators = useWatch({
        control,
        name: "indicators",
    });

    const selectedExchangeProfileObject = exchangeProfileSchema.parse(
        exchangeProfiles?.find((profile) => profile.title === exchangeProfile)
    );

    return (
        <Container>
            {!exchangeProfiles ? (
                <Stack py={20} direction="row" justifyContent="center">
                    <CircularProgress />
                </Stack>
            ) : (
                <Grid container spacing={4}>
                    <CreateValidatedQuestionFilters
                        exchangeProfiles={exchangeProfiles}
                        exchangeProfilesLoading={exchangeProfilesLoading}
                        selectedIndicators={selectedIndicators}
                        version={version}
                        exchangeProfile={exchangeProfile}
                        control={control}
                        errors={errors}
                    />
                    <CreateValidatedQuestionForm
                        version={version}
                        exchangeProfile={selectedExchangeProfileObject}
                        selectedIndicators={selectedIndicators}
                    />
                </Grid>
            )}
        </Container>
    );
};

export default CreateValidatedQuestion;
